import { Question } from '../../api/AppRoutes/UserRoutes/InterviewRoutes/Assets/InstructionTypes';

export enum PositionID {
  STANDARD = 'STANDARD',
  FINANCIAL_ADVISOR = 'FINANCIAL_ADVISOR',
}

export const PositionNames = {
  [PositionID.STANDARD]: 'Standard',
  [PositionID.FINANCIAL_ADVISOR]: 'Financial Advisor',
} as const;

export type PositionNameMap = typeof PositionNames;

export type PositionName = PositionNameMap[keyof PositionNameMap];

export const DEFAULT_POSITION_ID = PositionID.FINANCIAL_ADVISOR;

export type Position = {
  id: PositionID;
  name: PositionName;
};

export type InterviewFinalMessageSet = {
  positive: string;
  negative: string;
};

export type Interview = {
  position: Position;
  questions: Question[];
  finalMessages: InterviewFinalMessageSet;
};

export type InterviewMap = Record<PositionID, Interview>;
